import { Component, OnInit } from '@angular/core';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { UtilityServices } from '../../Services/UtilityService';
import { AuthService } from '../../Services/AuthService';
import { Router } from '@angular/router';
//import { debounce } from 'rxjs/operator/debounce';
//import * as CryptoJS from 'crypto-js';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressBarModule } from 'primeng/progressbar';
//import { EncryptionService } from 'angular-encryption-service';
import { CheckAuth } from '../../Services/UtilityService';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  tokenKey: string = "";
  key: any;
  iv: any;
  loginForm: FormGroup;
  userID: number;

  constructor(private _fb: FormBuilder, private utility: UtilityServices, private router: Router, private authService: AuthService, private checkAuth: CheckAuth) {
    this.userID = 0;
    //this.key = CryptoJS.enc.Utf8.parse('7061737323313233');
    //this.iv = CryptoJS.enc.Utf8.parse('7061737323313233');
    this.loginForm = this._fb.group({
      userid: 0,
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    })

    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  successMessage: any;
  isshowsuccess: boolean;
  errorMessage: any;
  isshowerror: boolean;
  isShowprogressSpinner: boolean;
  blockedPanel: boolean = false;
  blockedDocument: boolean = false;
  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showerror(msg) {
    this.errorMessage = msg;
    this.isshowerror = true;
    this.isshowsuccess = false;
    window.scrollTo(0, 0);
  }
  hideerror() {
    this.errorMessage = "";
    this.isshowerror = false;
  }
  showsuccess(msg) {
    this.successMessage = msg;
    this.isshowsuccess = true;
    this.isshowerror = false;
    window.scrollTo(0, 0);
  }
  ngOnInit(): void {
    this.isshowerror = false;
    this.isShowprogressSpinner = false;
    if (sessionStorage.getItem('UserId') != null) {
      this.router.navigate(['/Basic-Preference']);
    }
  }

  login(): void {
    debugger;
    if (!this.loginForm.valid) {
      return;
    }
    this.blockDocument();
    this.authService.blrlogin(this.loginForm.value.username, this.loginForm.value.password).subscribe(result => {
      debugger;
      if (result) {
        if (typeof (result) !== 'undefined' && (result) !== null) {
          try {
            //let a = result.json();
            if (result.user != undefined) {
              sessionStorage.setItem('UserId', "" + this.ecryption(result.user.id));
              this.router.navigate(['/Basic-Preference']);
            }
            else {
              this.showerror(result._body);
              this.unblockDocument();
            }
          } catch (e) {
            this.showerror(result._body);
            this.unblockDocument();
          }
        }
      }
      else {
        this.showerror("There is an error with login API call. Please try again later.");
        this.unblockDocument();
      }
    });

  }

  //ecryption(plaintext): any {
  //  this.encryption.add
  //  return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plaintext), this.key,
  //    {
  //      keySize: 128 / 8,
  //      iv: this.iv,
  //      mode: CryptoJS.mode.CBC,
  //      padding: CryptoJS.pad.Pkcs7
  //    });
  //}

  //decryption(encrypted): any {
  //  return CryptoJS.AES.decrypt(encrypted, this.key, {
  //    keySize: 128 / 8,
  //    iv: this.iv,
  //    mode: CryptoJS.mode.CBC,
  //    padding: CryptoJS.pad.Pkcs7
  //  });
  //}

  //GetplainText(dencryptedtext): any {
  //  if (dencryptedtext != null) {
  //    return this.decryption(dencryptedtext).toString(CryptoJS.enc.Utf8);
  //  }
  //  else {
  //    this.router.navigate(['/login']);
  //  }
  //}

  ecryption(plaintext): Promise<string> {
    //return this.encryptionService.generateKey('passphrase').then(key => {
    //  return this.encryptionService.encrypt(plaintext, key);
    //});
    return plaintext;
  }
  GetplainText(encryptedtext): Promise<string> {
    if (encryptedtext != null) {
      //return this.encryptionService.generateKey('passphrase').then(key => {
      //  return this.encryptionService.decrypt(encryptedtext, key);
      //});
      return encryptedtext;
    } else {
      this.router.navigate(['/login']);
    }
  }

  get username() { return this.loginForm.get('username'); }
  get password() { return this.loginForm.get('password'); }
}
